// Chemistry bar row — shows label, progress track, value, range
const RANGES = {
  cl:  { display: [0, 6],   ideal: [1, 5],   label: '1–3 ppm' },
  ph:  { display: [6.5, 9], ideal: [7.2, 7.8], label: '7.2–7.8' },
  alk: { display: [50, 150], ideal: [80, 120], label: '80–120' },
  cya: { display: [0, 80],  ideal: [30, 50],  label: '30–50' },
};

function chemColor(param, val) {
  const r = RANGES[param];
  if (!r) return 'var(--teal)';
  return (val >= r.ideal[0] && val <= r.ideal[1]) ? 'var(--teal)' : 'var(--rose)';
}

function chemPct(param, val) {
  const r = RANGES[param];
  if (!r) return 50;
  const [min, max] = r.display;
  return Math.min(100, Math.max(0, ((val - min) / (max - min)) * 100));
}

export default function ChemBar({ param, label, value }) {
  const color = chemColor(param, value);
  const pct   = chemPct(param, value);
  const range = RANGES[param]?.label || '';
  return (
    <div className="chem-row">
      <div className="chem-label">{label}</div>
      <div className="chem-track">
        <div className="chem-fill" style={{ width: `${pct}%`, background: color }} />
      </div>
      <div className="chem-val mono" style={{ color }}>{value}</div>
      <div className="chem-range">{range}</div>
    </div>
  );
}

export { chemColor, chemPct };
